import { Button } from "reactstrap";

const CollapseHeader = ({ title, isOpen, onClick }) => {
  return (
    <div
      className="d-flex justify-content-between align-items-center bg-ultralight border-top border-bottom border-superlight p-2 cursor-pointer"
      onClick={onClick}
    >
      <h5 className="text-dark m-0">{title}</h5>
      <Button
        size="sm"
        className="btn-icon-only"
        style={{
          height: "1.5rem",
          width: "1.5rem",
        }}
        outline
      >
        <i
          className={`mdi mdi-chevron-${isOpen ? "down" : "right"}`}
          style={{ fontSize: 20 }}
        />
      </Button>
    </div>
  );
};

export default CollapseHeader;
